import CrudModule from "../components/CrudModule";

const STATUS = [
  { value: "new", label: "New" },
  { value: "screening", label: "Screening" },
  { value: "interview", label: "Interview" },
  { value: "hired", label: "Hired" },
  { value: "rejected", label: "Rejected" },
];

export default function RecruitingPage() {
  return (
    <CrudModule
      testidPrefix="recruiting"
      resource="applicants"
      overline="TALENT PIPELINE"
      title="Driver Recruiting"
      subtitle="Onboard CDL drivers faster with AI-drafted outreach and structured screening."
      aiCategory="recruiting_outreach"
      aiContextFields={["name", "experience_years", "cdl_class", "status", "notes"]}
      primaryField="name"
      initialForm={{ status: "new", experience_years: 0, cdl_class: "A" }}
      fields={[
        { key: "name", label: "Name", required: true },
        { key: "phone", label: "Phone", required: true },
        { key: "email", label: "Email", type: "email" },
        { key: "experience_years", label: "Experience (years)", type: "number" },
        { key: "cdl_class", label: "CDL Class", type: "select", options: [
          { value: "A", label: "Class A" }, { value: "B", label: "Class B" }, { value: "C", label: "Class C" },
        ]},
        { key: "status", label: "Status", type: "select", options: STATUS },
        { key: "notes", label: "Notes", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "name", label: "APPLICANT" },
        { key: "phone", label: "PHONE", render: (r) => <span className="font-mono text-xs">{r.phone}</span> },
        { key: "experience_years", label: "EXP (Y)", render: (r) => <span className="font-mono">{r.experience_years}</span> },
        { key: "cdl_class", label: "CDL" },
        { key: "status", label: "STATUS" },
      ]}
    />
  );
}
